import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const decodeHashId = (hash: string) => {
  try {
    return decodeURIComponent(hash.slice(1));
  } catch {
    return hash.slice(1);
  }
};

/** Restores the document position for route changes while preserving deep-link anchors. */
const ScrollRestoration = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    let frame: number | undefined;
    let timeout: number | undefined;

    const restore = () => {
      if (hash) {
        const target = document.getElementById(decodeHashId(hash));
        if (target instanceof HTMLElement) {
          target.scrollIntoView({ block: 'start', inline: 'nearest' });
          if (target.hasAttribute('tabindex')) target.focus({ preventScroll: true });
        }
        return;
      }

      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    };

    if (typeof window.requestAnimationFrame === 'function') {
      frame = window.requestAnimationFrame(restore);
    } else {
      timeout = window.setTimeout(restore, 0);
    }

    return () => {
      if (frame !== undefined) window.cancelAnimationFrame(frame);
      if (timeout !== undefined) window.clearTimeout(timeout);
    };
  }, [pathname, hash]);

  return null;
};

export default ScrollRestoration;
